import { useRegionLanguage } from '@common/Context/RegionLanguageContext';
import { sanitizeURL } from './common-utils';

// eslint-disable-next-line import/prefer-default-export
export function useNavigationURL() {
  const { regionLang } = useRegionLanguage();

  const generateURL = (path) => {
    if (!path?.startsWith('/')) path = `/${path}`;
    return sanitizeURL(`/${regionLang}${path}`)
  };

  return generateURL;
}
